/* Issue #7 — UGC overrides:
   1. Inject theme-owned heading above the SocialWidget Instagram block.
   2. Flip .pdp-ugc-ready on the wrapper so our CSS hides widget heading + CTA.
   3. Ensure the swiper pagination element exists (some app builds lazy-init).
   4. Issue #18 (2026-05-15): hide the whole .pdp-ugc-wrap (incl. injected
      heading) when the SocialWidget renders empty for this product — avoids
      an orphan "MACHETE On You" heading sitting above blank space.
*/
(function () {
  'use strict';

  var HEADING_TEXT = (window.SM_UGC_HEADING || 'MACHETE On You');
  var EYEBROW_TEXT = (window.SM_UGC_EYEBROW || '120,000+ FOLLOWERS');

  // Check whether SocialWidget has content for the current product. App sets
  // data-initialized="1" after running, and on empty products it injects
  // inline `display: none` on the wrapper.
  function widgetIsEmpty(wrapper) {
    if (!wrapper) return true;
    if (wrapper.children.length === 0) return true;
    var inline = (wrapper.getAttribute('style') || '').toLowerCase();
    if (inline.indexOf('display: none') !== -1 || inline.indexOf('display:none') !== -1) return true;
    return false;
  }

  function syncShellVisibility(wrapper) {
    var shell = wrapper.closest('.pdp-ugc-wrap');
    if (!shell) return;
    shell.style.display = widgetIsEmpty(wrapper) ? 'none' : '';
  }

  function inject(wrapper) {
    if (wrapper.dataset.pdpUgcReady === '1') {
      syncShellVisibility(wrapper);
      return;
    }
    wrapper.dataset.pdpUgcReady = '1';

    // Wrap + eyebrow + heading per Figma Section-3
    var shell = document.createElement('div');
    shell.className = 'pdp-ugc-wrap pdp-ugc-ready';

    var eyebrow = document.createElement('p');
    eyebrow.className = 'pdp-ugc-eyebrow';
    eyebrow.textContent = EYEBROW_TEXT;
    shell.appendChild(eyebrow);

    var h2 = document.createElement('h2');
    h2.className = 'pdp-ugc-heading';
    h2.textContent = HEADING_TEXT;
    shell.appendChild(h2);

    var parent = wrapper.parentNode;
    if (!parent) return;
    parent.insertBefore(shell, wrapper);
    shell.appendChild(wrapper);

    // Hide shell up front so the heading never flashes before the widget
    // has had a chance to populate. Sync after init completes below.
    shell.style.display = 'none';
    syncShellVisibility(wrapper);
  }

  function init() {
    document.querySelectorAll('.social-widget-product-wrapper').forEach(inject);

    // Watch for the app's late content injection / display flip and re-sync
    // visibility each time the wrapper subtree changes.
    var mo = new MutationObserver(function (entries) {
      document.querySelectorAll('.social-widget-product-wrapper').forEach(function (w) {
        inject(w);
        syncShellVisibility(w);
      });
    });
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'data-initialized'] });
    setTimeout(function () { mo.disconnect(); }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
